import React from 'react';

const NotMatchingAnswersIcon = () => {
    return (
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.666016 8C0.666016 3.58172 4.24774 0 8.66602 0H24.666C29.0843 0 32.666 3.58172 32.666 8V24C32.666 28.4183 29.0843 32 24.666 32H8.66602C4.24774 32 0.666016 28.4183 0.666016 24V8Z"
                fill="url(#paint0_linear_3690_29824)" />
            <path d="M22.666 10L10.666 22" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.666 10L22.666 22" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3690_29824" x1="-1.58079" y1="1.05205e-05" x2="33.7981" y2="1.16908" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2547D" />
                    <stop offset="1" stopColor="#FF7959" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export default NotMatchingAnswersIcon;